import { LandingPageService } from './../../../../core/services/landing-page.service';
import { Component,HostListener, OnInit } from '@angular/core';
// import 'slick-carousel';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
import { Router } from '@angular/router';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Subscription } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API } from 'aws-amplify';
import { environment } from 'src/environments/environment';
import { CONST_AWS_API, DEFAULT_IMAGE } from 'src/app/core/constants';
import * as moment from 'moment';
import { StorageService } from 'src/app/core/services/storage.service';
declare let window: any;

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss']
})
export class CategoryListComponent implements OnInit {

  userInfoSubscription: Subscription;
  userInfo: any = {};
  liveEventList: any = [];
  isLoadingLiveEvent: boolean = true;
  categoryList: any = [];
  isShowBannerSlider: boolean = false;
  eventList: any = {};
  bannerList = [];
  isLoadingEvent: boolean = true;
  isLoadingChannel: boolean = true;
  trendingChannels: any = [];
  liveUpcomingEvents: any = [];
  maxBannerList: any = 20;
  hideSection: any = true;
  isShow : boolean = false;
  liveEventInfo: any;
  constructor(private router: Router, private landingPageService: LandingPageService,
    private ngxLoader: NgxUiLoaderService,
    private commanSubscribeService: CommanSubscribeService,
    private storageService: StorageService) {
    this.commanSubscribeService.initSlider('.loader-slider1');
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (!this.isShow) {
      this.getTrendingChannels();
      return;
    }
  }

  ngOnInit(): void {
    this.userInfo = this.commanSubscribeService.userInfo;
    if (this.userInfo && Object.keys(this.userInfo)?.length != 0) {
      this.router.navigate(['/userhome']);
    }
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.commanSubscribeService.initSlider('.loader-slider1');
    this.getEvents();
    // this.getTrendingChannels();
    //this.getLiveEventList();
    // this.getCategory();
  }
  navigateToFragment(from){
    let fragments = this.router.url.split("#");
    let fragment = fragments[fragments.length-1];
    if (fragment && document.getElementById(fragment) != null && from == fragment) {
      console.log(this.router.url);
      console.log("fragment", fragment);
      document.getElementById(fragment).scrollIntoView({ behavior: "smooth" });
    }
  }
  getEvents() {
    let myInit = {
      headers: {
        'x-api-key': environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: {}
    }
    this.eventList.upcoming_events = [];
    this.eventList.live_events = [];
    this.ngxLoader.start();
    this.isLoadingEvent = true;
    API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.EVENTS, myInit).then(response => {
      this.isLoadingEvent = false;
      this.ngxLoader.stop();
      if (response.data.statusCode === '200' && response.data.Data) {
        this.commanSubscribeService.initSlider(".channels-images-slider1");
        this.eventList = response.data.Data;

        this.bannerList = [];
        //this.liveUpcomingEvents = this.eventList.live_events ? this.eventList.live_events.concat(this.eventList.upcoming_events) : this.eventList.upcoming_events;
        let liveEvent = this.eventList.live_events;
        liveEvent.forEach(e => {
          e=e.stream_info;
          e.isEvent = "live";
          if (!e.video_banner_image)
            e.video_banner_image = DEFAULT_IMAGE.IMAGE_1;
            this.liveUpcomingEvents.push(e);
        });

        // if (this.eventList.organizations && this.eventList.organizations.length > 0) {
        //   this.eventList.organizations.forEach(e => {
        //     e.organizationInfo.name = e.organizationInfo.organizationName;
        //     e.organizationInfo.logo = e.organizationInfo.logo || DEFAULT_IMAGE.IMAGE_1;
        //     if (!e.organizationInfo.video_thumbnail_image) {
        //       e.organizationInfo.video_thumbnail_image = DEFAULT_IMAGE.IMAGE_1;
        //     }
        //     if (!e.organizationInfo.banner) {
        //       e.organizationInfo.video_banner_image = DEFAULT_IMAGE.IMAGE_2;
        //     } else {
        //       e.organizationInfo.video_banner_image = e.organizationInfo.banner;
        //     }
        //     if (this.bannerList.length < this.maxBannerList) {
        //       e.organizationInfo.isEvent = "organization";
        //       if(!e.organizationInfo.banner_text) {
        //         e.organizationInfo.banner_text = "";
        //       }
        //       e.organizationInfo.organization_name=e.organization_name;
        //       //e.short_description = (e.short_description.length > 300) ? e.short_description.substring(0, 300)+"..." : e.short_description;
        //       this.bannerList.push(e.organizationInfo);
        //     }
        //   });
        // }
        /*if (this.eventList.live_events && this.eventList.live_events.length > 0) {
          this.eventList.live_events.forEach(e => {
            e.name = e.user_first_name + ' ' + e.user_last_name;
            e.logo = e.organization_logo || DEFAULT_IMAGE.IMAGE_1;
            if (!e.video_thumbnail_image) {
              e.video_thumbnail_image = DEFAULT_IMAGE.IMAGE_1;
            }
            if (!e.video_banner_image) {
              e.video_banner_image = DEFAULT_IMAGE.IMAGE_2;
            }
            if (this.bannerList.length < this.maxBannerList) {
              e.isEvent = "live";
              if(!e.short_description) {
                e.short_description = "";
              }
              //e.short_description = (e.short_description.length > 300) ? e.short_description.substring(0, 300)+"..." : e.short_description;
              this.bannerList.push(e);
            }
          });
        }*/
        if (this.eventList.upcoming_events && this.eventList.upcoming_events.length > 0) {
          this.eventList.upcoming_events.forEach(e => {
            e = e.stream_info;
            e.name = e.user_first_name + ' ' + e.user_last_name;
            e.logo = e.organization_logo || DEFAULT_IMAGE.IMAGE_1;
            if (!e.video_thumbnail_image) {
              e.video_thumbnail_image = DEFAULT_IMAGE.IMAGE_1;
            }
            if (!e.video_banner_image) {
              e.video_banner_image = DEFAULT_IMAGE.IMAGE_2;
            }
            if (this.bannerList.length < this.maxBannerList) {
              let localTime = moment.utc(e.publish_date_time).toDate();
              e.publish_date_time = moment(localTime).format('DD MMM YYYY, hh:mm A');
              //e.publish_date_time = moment(e.publish_date_time).format("DD MMM YYYY hh:mm A");
              e.isEvent = "upcoming";
              if(!e.short_description) {
                e.short_description = "";
              }
              if(e.stream_video_title.includes('Jamaican All-Stars Carnival Special')){
                let title = e.stream_video_title.split(" ");
                e.first_line = title[0] +' ' + title[1];
                e.second_line = title[2] +' ' + title[3];
              }
              //e.short_description = (e.short_description.length > 300) ? e.short_description.substring(0, 300)+"..." : e.short_description;
              this.bannerList.push(e);
            }
          });
        }
        // if (this.eventList.channels && this.eventList.channels.length > 0) {
        //   this.eventList.channels.forEach(e => {
        //     e.name = e.performer_details.performer_display_name;
        //     e.logo = e.performer_details.performer_profile_pic ? e.performer_details.performer_profile_pic : DEFAULT_IMAGE.IMAGE_1;
        //     e.video_banner_image = e.performer_details.performer_profile_banner ? e.performer_details.performer_profile_banner : DEFAULT_IMAGE.IMAGE_2;
        //     e.isEvent = "channels";
        //     if(e.performer_details.performer_bio) {
        //       e.performer_bio = (e.performer_details.performer_bio.length > 150) ? e.performer_details.performer_bio.substring(0, 150)+"..." : e.performer_details.performer_bio;
        //       this.bannerList.push(e);
        //     }
        //   });
        // }
        if (this.eventList.vod && this.eventList.vod.length > 0) {
          this.eventList.vod.forEach(e => {
            e = e.stream_info;
            e.name = e.user_first_name + ' ' + e.user_last_name;
            e.logo = e.organization_logo || DEFAULT_IMAGE.IMAGE_1;
            if (!e.video_thumbnail_image) {
              e.video_thumbnail_image = DEFAULT_IMAGE.IMAGE_1;
            }
            if (!e.video_banner_image) {
              e.video_banner_image = DEFAULT_IMAGE.IMAGE_2;
            }
            e.isEvent = "vod";
            if(!e.short_description) {
              e.short_description = "";
            }
            //e.short_de = (e.short_description.length > 300) ? e.short_description.substring(0, 300)+"..." : e.short_description;
            this.bannerList.push(e);
          });
        }
        setTimeout(() => {
          this.navigateToFragment("liveevents");
        }, 1000);
        this.isShowBannerSlider = this.bannerList.length != 0;
      }
    }).catch(error => {
      this.isLoadingEvent = false;
      this.ngxLoader.stop();
    });
  }

  goToSignUp(data){
    let eventInfo = {
      "isEvent":data.isEvent,
      "number_of_creators" : data.number_of_creators,
      "channel_name": data.channel_name,
      "id":data.id,
      "slug":data.slug
    }
    this.storageService.setItem("eventInfo", eventInfo);
    this.router.navigateByUrl(`event/${data.slug}`);
  }

  getLiveEventList() {
    let myInit = {
      headers: {
        'x-api-key': environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: null
    }
    this.ngxLoader.start();
    this.isLoadingLiveEvent = true;
    API.get(environment.AWS_Cognito.apiName, CONST_AWS_API.ON_GOING_EVENTS, myInit).then(response => {
      this.isLoadingLiveEvent = false;
      this.ngxLoader.stop();
      if (response && response.data && response.data.Data) {
        // let data = response.data.Data;
        // data.forEach(e => {
        //   if (!e.video_banner_image)
        //     e.video_banner_image = DEFAULT_IMAGE.IMAGE_1;
        // });
        this.liveEventList = response.data.Data;
        let liveEvent = this.liveUpcomingEvents;
        liveEvent.forEach(e => {
          if (!e.video_banner_image)
            e.video_banner_image = DEFAULT_IMAGE.IMAGE_1;
        });
        this.liveUpcomingEvents = liveEvent;
        setTimeout(() => {

          this.navigateToFragment("liveevents");
          this.commanSubscribeService.initSlider('.customer-logos');
        }, 1000);
      }
    }).catch(error => {
      this.isLoadingLiveEvent = false;
      this.ngxLoader.stop();
    });
  }
  getTrendingChannels() {
    this.isShow = true;
    let myInit = {
      headers: {
        'x-api-key': environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: null
    }
    this.ngxLoader.start();
    this.isLoadingChannel = true;
    API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.TRENDING_CHANNELS, myInit).then(response => {
      this.isLoadingChannel = false;
      this.ngxLoader.stop();
      if (response && response.data && response.data.Data) {
        console.log(response);
        let data = response.data.Data;
        data.forEach(e => {
          if (!e.performer_profile_pic)
            e.performer_profile_pic = DEFAULT_IMAGE.IMAGE_1;
        });
        data.forEach(e => {
          if (!e.performer_profile_pic)
            e.performer_profile_pic = DEFAULT_IMAGE.IMAGE_1;
        });
        this.trendingChannels = data;
        this.commanSubscribeService.initSlider('.channels-images-slider3');
      }
      setTimeout(() => {

        this.navigateToFragment("trendingchannels");
      }, 200);
    }).catch(error => {
      this.isLoadingChannel = false;
      this.ngxLoader.stop();
    });
  }
  // getCategory() {
  //   let myInit = {
  //     headers: {
  //       'x-api-key': environment.AWS_Cognito.X_Api_Key
  //     },
  //     response: true,
  //     body: {}
  //   }
  //   this.ngxLoader.start();
  //   API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.CATEGORIES, myInit).then(response => {
  //     this.ngxLoader.stop();
  //     if (response.data.statusCode === '200') {
  //       if (response.data.Data) {
  //         response.data.Data.forEach(e => {
  //           if (e.subcategory) {
  //             e.subcategory.forEach(c => {
  //               if (c.subCategory && c.subCategory.indexOf(" & ") != -1) {
  //                 c.category_image = c.subCategory.replace(/\//g, "").toLowerCase().replace(/ & /g, "-") + ".jpg";
  //                 c.category_image = c.category_image.replace(/\//g, "").toLowerCase().replace(/ /g, "-");
  //               } else if (c.subCategory && c.subCategory == "Professional wrestling/Sports entertainment") {
  //                 c.category_image = "Professional wrestling Sports entertainment";
  //                 c.category_image = c.category_image.replace(/\//g, "").toLowerCase().replace(/ /g, "-") + ".jpg";
  //               } else if (c.subCategory) {
  //                 c.category_image = c.subCategory.replace(/\//g, "").toLowerCase().replace(/ /g, "-") + ".jpg";
  //               }
  //               c.category_image = "assets/category/" + c.category_image;
  //             });
  //           }
  //         });
  //         this.categoryList = response.data.Data || [];
  //         this.commanSubscribeService.initSlider('.channels-images-slider2');
  //       }
  //     }
  //   }).catch(error => {
  //     this.ngxLoader.stop();
  //   });
  // }

  goToCategory(cat, subCat) {
    this.router.navigateByUrl(`home/${cat}/${subCat}`);
  }
  goToCreator(page) {
    window.location.href=environment.VENDOR_PORTAL+page;
  }
  goToOrganization(data) {
    this.commanSubscribeService.sendSearchInfo('channels');
    this.router.navigateByUrl(`/c/${data.channel_name}/profile`);
  }
  redirectToUserHome(data) {
    let eventInfo = {
      "isEvent":data.isEvent,
      "number_of_creators" : data.number_of_creators,
      "channel_name": data.channel_name,
      "id":data.id,
      "slug":data.slug
    }
    this.storageService.setItem("eventInfo", eventInfo);
    this.commanSubscribeService.sendSearchInfo(data.isEvent);
    if (data.isEvent == 'upcoming' || data.isEvent == 'live') {
      // if (data.number_of_creators > 1) {
      //   this.router.navigateByUrl(`/group-stream/${data.id}`);
      // } else {
        this.router.navigateByUrl(`/stream/${data.id}`);
      // }
    } else if (data.isEvent == 'vod') {
      this.router.navigateByUrl(`${this.router.url.split("/")[1]}/watch/${data.id}`);
      // this.router.navigateByUrl(`/c/${data.channel_name}/${data.performer_id}/vod/${data.id}`);
    } else if (data.isEvent == 'channel') {
      this.router.navigateByUrl(`/c/${data.channel_name}/profile`);
    } else if (data.isEvent == 'organization') {
      this.router.navigateByUrl(`/${data.organization_name}`);
    }
  }

  openLogin() {
    this.landingPageService.openConsumerSignIn();
  }

  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
  }

}
